<script setup lang="ts">
  import { selectedGameVersion } from '@/helpers/selectedGameVersion'

  const props = defineProps({
    menu: {
      type: Object as PropType<RouteRecordRaw>,
      required: true,
    },
    // this is for ga tracking
    parentName: {
      type: String,
      default: '',
    },
  })

  const route = useRoute()
  const router = useRouter()

  // Entries with a Classic twin (`meta.worldToggle`) open whichever world was picked last.
  const target = computed<RouteLocationRaw>(() => {
    const pair = props.menu.meta?.worldToggle
    return pair && selectedGameVersion.value === 'mscw' ? pair.classicRoute : { name: props.menu.name }
  })
  const selected = computed(() => {
    const name = router.resolve(target.value).name
    return route.matched.some((record) => record.name === name)
  })
</script>
<template>
  <a
    v-if="menu.path == '__'"
    v-ga-event="`${parentName ? parentName + ' - ' : ''}${menu.meta?.menuTitle}`"
    :href="String(menu.redirect)"
    target="_blank"
  >
    {{ menu.meta?.menuTitle }}
    <i-local-external-link class="external-link" />
  </a>
  <router-link
    v-else
    v-ga-event="`${parentName ? parentName + ' - ' : ''}${menu.meta?.menuTitle}`"
    :class="{ selected }"
    :to="target"
  >
    {{ menu.meta?.menuTitle }}
  </router-link>
</template>

<style lang="scss" scoped>
  .external-link {
    margin-left: 10px;
    //   opacity: 0.7;
    width: 9px;
    vertical-align: middle;
  }

  a {
    display: block;
    text-decoration: none;
    user-select: none;
    color: var(--nav-font-c);
    &.selected {
      pointer-events: none;
    }
  }
</style>
